import { SearchParamsModel } from '../components/utils/constants';
import Properties from '../assets/data/properties.json';
import PropertiesEV from '../assets/data/properties.EV.json';
import {
  IAvailability,
  IAvailabilityRateCode,
  IChild,
  ICouponRateCodeStatamic,
  IOrder, ISearchParams
} from '../interfaces/bookingContext';
import i18n from 'i18next';
import { getRoomTypeDetails } from './requests';
import { IAccommodationBoardsInfo, IAccommodationMoreInfo, IRateTerms } from '../interfaces/huWebsite';
import axios, { AxiosResponse } from 'axios';
import { IProfile } from '../interfaces/suite8';
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear.js';
import {ISearchForm} from "../interfaces/bookingManagementContext";

dayjs.extend(dayOfYear);

export const getCurrentWebsite = (): string => {
  const domain = window.location.hostname;
  let websiteCode;
  switch (domain) {
    case 'altomincio.humancompany.com':
    case 'altomincio.huopenair.com':
      websiteCode = 'AM';
      break;
    case 'jolly.humancompany.com':
    case 'jolly.huopenair.com':
    case 'venezia.huopenair.com':
      websiteCode = 'JO';
      break;
    case 'firenze.humancompany.com':
    case 'firenze.huopenair.com':
      websiteCode = 'CF';
      break;
    case 'norcenni.humancompany.com':
    case 'norcenni.huopenair.com':
      websiteCode = 'NG';
      break;
    case 'parkalbatros.humancompany.com':
    case 'parkalbatros.huopenair.com':
      websiteCode = 'PA';
      break;
    case 'montescudaio.humancompany.com':
    case 'montescudaio.huopenair.com':
      websiteCode = 'MS';
      break;
    case 'roma.humancompany.com':
    case 'roma.huopenair.com':
      websiteCode = 'RO';
      break;
    case 'fabulous.humancompany.com':
    case 'fabulous.huopenair.com':
      websiteCode = 'FA';
      break;
    case 'ipini.humancompany.com':
    case 'ipini.huopenair.com':
      websiteCode = 'IP';
      break;
    case 'birkelt.humancompany.com':
    case 'birkelt.huopenair.com':
      websiteCode = 'BK';
      break;
    case 'humantravel.com':
    case 'www.humantravel.com':
      websiteCode = 'EV';
      break;
    case 'humancompany.com':
      websiteCode = 'HU';
      break;
    case 'palagina.it':
    case 'www.palagina.it':
      websiteCode = 'VP';
      break;
    case 'fattorialapalagina.it':
      websiteCode = 'LC';
      break;
    case 'ladigahotel.com':
      websiteCode = 'LD';
      break;
    case 'villanorcenni.com':
      websiteCode = 'VN';
      break;
    case 'ilmulinacciohotel.com':
      websiteCode = 'MU';
      break;
    case 'campinginternazionalefirenze.com':
    case 'firenzecertosacamping.com':
      websiteCode = 'CE';
      break;
    default:
      websiteCode = 'IP';
  }
  return websiteCode;
};

export const getDataFromUrl = (query: any) => {
  const searchParamsModel = SearchParamsModel;

  if (query.get('property')) {
    searchParamsModel.property = String(query.get('property'));
  }
  if (
    dayjs(query.get('GuestArrival'), 'DD.MM.YYYY', true).isValid() &&
    dayjs(query.get('GuestDeparture'), 'DD.MM.YYYY', true).isValid()
  ) {
    searchParamsModel.GuestArrival = dayjs(query.get('GuestArrival'), 'DD.MM.YYYY');
    searchParamsModel.GuestDeparture = dayjs(query.get('GuestDeparture'), 'DD.MM.YYYY');
  }
  if (query.get('NoOfAdults')) {
    searchParamsModel.NoOfAdults = Number(query.get('NoOfAdults'));
  }
  if (query.get('coupon')) {
    searchParamsModel.Coupon = String(query.get('coupon'));
  }
  if (query.get('pet')) {
    searchParamsModel.Pets = true;
  }

  if (Number(query.get('CA1')) > 0) {
    searchParamsModel.Child.CA1 = query.get('CA1');
  }

  if (Number(query.get('CA2')) > 0) {
    searchParamsModel.Child.CA2 = query.get('CA2');
  }

  if (Number(query.get('CA3')) > 0) {
    searchParamsModel.Child.CA3 = query.get('CA3');
  }

  if (Number(query.get('CA4')) > 0) {
    searchParamsModel.Child.C4 = query.get('CA4');
  }

  return [{ ...searchParamsModel }];
};

export const getProperties = (): any[] => {
  const website: string = getCurrentWebsite();
  if (website === 'EV') {
    return PropertiesEV;
  }
  return Properties;
};

export const getProperty = (code: string) => {
  return getProperties().find((p: any) => p.code === code);
};

export const isPropertyClosed = (e: any, openings: any[] = []) => {
  let enabled = false;

  openings.forEach((opening: any) => {
    if (e.isBetween(opening.from, opening.to, 'days', '[]')) {
      enabled = true;
    }
  });

  return !enabled;
};

export const getLabelOffer = (availabilityRateCode: any) => {
  let bigPrice =
    availabilityRateCode.Price > availabilityRateCode.PriceStroked
      ? availabilityRateCode.Price
      : availabilityRateCode.PriceStroked;
  let lowPrice =
    availabilityRateCode.Price < availabilityRateCode.PriceStroked
      ? availabilityRateCode.Price
      : availabilityRateCode.PriceStroked;
  return '-' + Math.round(Math.abs(((lowPrice - bigPrice) / bigPrice) * 100)) + '%';
};

export const getStringFromRateDesc = (availabilityRateCode: IAvailabilityRateCode): string => {
  if (
    availabilityRateCode.RateCodeCouponStatamic &&
    availabilityRateCode.RateCodeCouponStatamic.lista_ratecode
  ) {
    const StatamicRate = availabilityRateCode.RateCodeCouponStatamic.lista_ratecode.find(
      (r: ICouponRateCodeStatamic) => r.RateCode === availabilityRateCode.RateCode
    );
    if (StatamicRate && StatamicRate.RateCodeDescription !== '') {
      return ' | ' + StatamicRate.RateCodeDescription;
    }
  }

  let str = '';
  if (availabilityRateCode.RateCodeDetails.RateName.indexOf('MIN_') > -1) {
    str = i18n.t('rate_MS', {
      params: {
        NIGHTS: availabilityRateCode.RateCodeDetails.RateMinLOS
      }
    });

    str = ' - ' + str;
    return str;
  }

  const showRateNameIn = ['W0', 'W1', 'W2', 'W3', 'W4', 'W5', 'W6',  'W7', 'W8'];

  if (showRateNameIn.includes(availabilityRateCode.RateCode.substring(0, 2))) {
    str = ' - ';

    str += availabilityRateCode.RateCodeCouponStatamic
      ? availabilityRateCode.RateCodeCouponStatamic.title
      : availabilityRateCode.RateCodeDetails.RateName;

    return str;
  }

  return str;
};

export const getStringFromRateDescByOrder = (
  availability: IAvailability[],
  RoomType: String,
  RateCode: String
) => {
  const room = availability.find((av) => av.RoomTypeShortDesc === RoomType);
  if (room) {
    const rate = room.RateCodes.find((rc) => rc.RateCode === RateCode);
    if (rate) {
      return getStringFromRateDesc(rate);
    } else {
      return '';
    }
  } else {
    return '';
  }
};

export const getDestinationsListByWebsite = () => {
  let destinations: string[] = [];
  const properties = getProperties();

  properties.forEach((property: any) => {
    destinations = destinations.concat(property.destination);
  });

  return destinations.filter((v, i, a) => a.indexOf(v) === i);
};

export const getPropertiesByDestination = (destination: string) => {
  const website: string = getCurrentWebsite();
  const properties = getProperties();

  if (website === 'HU' || website === 'EV') {
    if (destination === 'all') return properties;
    return properties.filter((property: any) => property.destination.includes(destination));
  }

  return properties.filter((p: any) => p.code === website);
};

export const getCurrentPropertyObject = () => {
  const website = getCurrentWebsite();
  return getProperties().find((property) => property.property === website);
};

export const getDepositDays = () => {
  return getCurrentPropertyObject()?.deposit_days ? Number(getCurrentPropertyObject().deposit_days) : 0;
};

export const propertyByWebsite = (website: string): string => {
  const property = getProperties().find((property) => property.code === website);
  return property ? property.property : website;
};

export const getRoomTypeDetailsByWebSite = async (PropertyCode: string) => {
  const setLanguageHeader = () => {
    axios.defaults.headers.common['Accept-Language'] = i18n.language;
  };

  setLanguageHeader();

  const property: any = getProperties().find((p: any) => p.code === PropertyCode);

  return await getRoomTypeDetails({ url: property.info_end_point });
};

export const getMoreInfo = async (property: string) => {
  const res: AxiosResponse<any[]> = (await getRoomTypeDetailsByWebSite(property)) || [];
  if (res.data) {
    if (getCurrentWebsite() === 'EV') {
      let rooms: IAccommodationMoreInfo[] = [];
      let properties = getProperties();
      res.data.forEach((r: IAccommodationMoreInfo) => {
        properties.forEach((p: any) => {
          let room_copy: IAccommodationMoreInfo = {} as IAccommodationMoreInfo;
          Object.assign(room_copy, r);
          room_copy.room_id = p.code + room_copy.room_id;
          rooms.push({ ...room_copy });
        });
      });
      return rooms;
    } else {
      return res.data;
    }
  } else {
    return [];
  }
};

export const getBoardInfo = async (property: string) => {
  let propertyObj = getProperty(property);
  const x = await getRoomTypeDetails({
    url: propertyObj.boards_end_point
  });
  return x.data;
};

export const getTermsInfo = async (property: string) => {
  let propertyObj = getProperty(property);
  const x = await getRoomTypeDetails({
    url: propertyObj.rate_terms_end_point
  });
  return x.data;
};

export const getBoardInfoBy = (
  boardInfo: IAccommodationBoardsInfo[],
  BoardRateCode: string,
  RoomType: string
): IAccommodationBoardsInfo => {
  let board: IAccommodationBoardsInfo | undefined = {
    terms_description: '',
    title: ''
  };
  const RoomCategoryCode = RoomType.slice(0, 2);

  board = boardInfo.find((bI) => bI.code === BoardRateCode + '_' + RoomCategoryCode);
  if (board && board.terms_description) {
    board = {
      ...board,
      terms_description: board.terms_description.replace(/(<([^>]+)>)/gi, '')
    };
    return board;
  }
  board = boardInfo.find((bI) => bI.code === BoardRateCode);
  if (board && board.terms_description) {
    board = {
      ...board,
      terms_description: board.terms_description.replace(/(<([^>]+)>)/gi, '')
    };
    return board;
  }

  return board as IAccommodationBoardsInfo;
};

export const getCouponInfoBy = (availabilityRateCode: IAvailabilityRateCode) => {
  if (
    availabilityRateCode.RateCodeCouponStatamic &&
    availabilityRateCode.RateCodeCouponStatamic.lista_ratecode
  ) {
    const StatamicRate = availabilityRateCode.RateCodeCouponStatamic.lista_ratecode.find(
      (r: ICouponRateCodeStatamic) => r.RateCode === availabilityRateCode.RateCode
    );
    if (StatamicRate && StatamicRate.RateCodeDescription !== '') {
      return ' | ' + StatamicRate.RateCodeDescription;
    }
  }

  return !availabilityRateCode.RateCodeCouponStatamic
    ? ''
    : '| ' + availabilityRateCode.RateCodeCouponStatamic.title;
};

export const getRateCodeDetail = (rateTerms: IRateTerms[], term: string, key = 'title'): string => {
  const x: any = rateTerms.find((t: IRateTerms) => t.code === term);
  if (x !== undefined && x[key]) {
    return x[key].replace(/(<([^>]+)>)/gi, '');
  } else {
    return '';
  }
};

const getChildrenCountFromOrder = (order: IOrder): number => {
  let count = 0;

  if (order.Child) {
    order.Child.forEach((child: IChild) => (count += child.node));
  }

  return count;
};
const getGtmPurchaseObjectVP = (order: IOrder) => {
  const gtmPurchase = {
    currencyCode: 'EUR',
    actionField: {
      id: order.GuestNum,
      affiliation: window.location.hostname,
      revenue: order.TotalStay,
      tax: 0,
      shipping: 0,
      coupon: order.RateCode,
      option: 'axerve'
    },
    products: [
      {
        name: order.RoomType,
        id: order.Property + '_' + order.GuestNum,
        price: order.TotalStay,
        brand: 'VP',
        category: order.Property,
        variant: '',
        quantity: 1,
        dimension4: order.RoomType, // Tipo Alloggio
        dimension5: '10', // RoomTypeMaxPAX
        dimension6: order.NoOfAdults, // Total guest TODO add children
        dimension7: order.NoOfAdults, // Adults
        dimension8: getChildrenCountFromOrder(order), // Children
        dimension9: dayjs(order.GuestDeparture, 'DD.MM.YYYY').diff(
          dayjs(order.GuestArrival, 'DD.MM.YYYY'),
          'days'
        ), // Quantità di giorni
        dimension10:
          dayjs(order.GuestArrival, 'DD.MM.YYYY').dayOfYear().toString().padStart(3, '0') +
          '_' +
          dayjs(order.GuestArrival, 'DD.MM.YYYY').format('Y'),
        dimension11: order.RateCode.split('_')[1],
        dimension12: '', // Extra
        dimension14: localStorage.getItem('customer_id')
      }
    ]
  };
  return gtmPurchase;
};

const getGtmPurchaseObjectHC = (order: IOrder) => {
  const gtmPurchase = {
    currencyCode: 'EUR',
    actionField: {
      id: order.GuestNum,
      affiliation: window.location.hostname,
      revenue: order.TotalStay,
      tax: 0,
      shipping: 0,
      coupon: order.RateCode,
      option: 'axerve'
    },
    products: [
      {
        name: order.RoomType,
        id: order.Property + '_' + order.GuestNum,
        price: order.TotalStay,
        brand: 'HC',
        category: order.Property,
        variant: '',
        quantity: 1,
        dimension4: 'VI', // Tipo Struttura
        dimension5: '6', // RoomTypeMaxPAX
        dimension6: order.NoOfAdults + getChildrenCountFromOrder(order), // Total guest
        dimension7: order.NoOfAdults, // Adults
        dimension8: getChildrenCountFromOrder(order), // Children
        dimension9: dayjs(order.GuestArrival, 'DD.MM.YYYY').format('Y'),
        dimension10: dayjs(order.GuestArrival, 'DD.MM.YYYY')
          .dayOfYear()
          .toString()
          .padStart(3, '0'),
        dimension11: order.RateCode.split('_')[1],
        dimension12: '',
        dimension13: 'IT'
      }
    ]
  };
  return gtmPurchase;
};

const getGtmPurchaseObjectEV = (order: IOrder) => {
  return {
    currencyCode: 'EUR',
    actionField: {
      id: order.GuestNum,
      affiliation: window.location.hostname,
      revenue: order.TotalStay,
      tax: 0,
      shipping: 0,
      coupon: order.RateCode,
      option: 'stripe'
    },
    products: [
      {
        name: order.RoomType,
        id: order.Property.slice(0, 2) + '_' + order.GuestNum,
        price: order.TotalStay,
        brand: 'HT',
        category: order.Property,
        variant: '',
        quantity: 1,
        dimension4: 'VI', // Tipo Struttura
        dimension5: '6', // RoomTypeMaxPAX
        dimension6: order.NoOfAdults, // Total guest
        dimension7: order.NoOfAdults, // Adults
        dimension8: getChildrenCountFromOrder(order), // Children
        dimension9: dayjs(order.GuestArrival, 'DD.MM.YYYY').format('Y'),
        dimension10: dayjs(order.GuestArrival, 'DD.MM.YYYY')
          .dayOfYear()
          .toString()
          .padStart(3, '0'),
        dimension11: order.RateCode.split('_')[1],
        dimension12: '',
        dimension13: 'IT'
      }
    ]
  };
};

export const getGtmPurchaseObject = (order: IOrder) => {
  let gtm: any;
  switch (getCurrentWebsite()) {
    case 'VP':
      gtm = getGtmPurchaseObjectVP(order);
      break;
    case 'AM':
    case 'FA':
    case 'NG':
    case 'MS':
    case 'PA':
    case 'IP':
    case 'CF':
    case 'JO':
    case 'BK':
    case 'RO':
      gtm = getGtmPurchaseObjectHC(order);
      break;
    case 'EV':
      gtm = getGtmPurchaseObjectEV(order);
      break;
  }

  return gtm;
};

export const getCookie = (cname: string) => {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const getTradeTrackerCookie = () => {
  const prefix = 'TT2_';
  const splitTT2 = document.cookie.split(prefix);
  if (splitTT2.length > 1) {
    return prefix + splitTT2[1].split('=')[0];
  } else {
    return null;
  }
};

export const getPayerFromOrders = (orders: IOrder[]): IProfile | null => {
  const firstBookerID = orders[0].BookerID;

  for (const order of orders) {
    if (order.profiles) {
      const profile = order.profiles.find(
        (profile: IProfile) => profile.ProfileID === firstBookerID
      );
      if (profile) {
        return profile;
      }
    }
  }
  return null;
};

export const setIsVisible = (availability: IAvailability[], searchForm: ISearchParams): IAvailability[] => {

  availability
    .map((av: IAvailability) => {

      if (searchForm.Coupon && searchForm.Coupon.length > 3) {
        av.RateCodes.map((rateCode: IAvailabilityRateCode) => (rateCode.isVisible = rateCode.RateCodeCouponStatamic?.Code === searchForm.Coupon) );
      } else {
        const typeRates: Set<string> = new Set();
        av.RateCodes.forEach( rate => {
          let type = rate.RateCode.split('_');
          type.shift()
          typeRates.add(type.join('_'))
        })

        const RateCodesVisible: string[] = [];
        typeRates.forEach( (type) => {
          const minPriceProduct = av.RateCodes.filter( rate => rate.RateCode.endsWith(type) ).reduce((min, current) => (current.Price < min.Price ? current : min), av.RateCodes.find(rate => rate.RateCode.endsWith(type)) ?? av.RateCodes[0]);
          RateCodesVisible.push(minPriceProduct.RateCode)
        })

        av.RateCodes.map((rateCode: IAvailabilityRateCode) => (rateCode.isVisible = RateCodesVisible.includes(rateCode.RateCode)));
      }
      return av
    });

  return availability;
};

export const isPaymentRequired = (rateCode: string): boolean =>
  ['AS', 'AX', 'NR'].includes(rateCode.slice(-2));

export const devToolsShowIf = () => {
  return (
    window.location.host.indexOf('localhost') > -1 ||
    window.location.host.indexOf('azurestaticapps.net') > -1 ||
    localStorage.getItem('role') === 'admin'
  );
};

export const isRecaptchaVisible = () => !isPingdom();

const isPingdom = () => {
  return  true;
  return window.navigator.userAgent.toLowerCase().indexOf('pingdom') !== -1;
};
